import React from "react";

import Corpo from "../components/Corpo";

export default function TabFaq(props) {
  
  let openLinkPwaAndroid = () => {
    window.open("https://support.google.com/chrome/answer/9658361?co=GENIE.Platform%3DAndroid&hl=pt-BR", "_blank");
  };

  let openLinkPwaComputador = () => {
    window.open("https://support.google.com/chrome/answer/9658361?co=GENIE.Platform%3DDesktop&hl=pt-BR&oco=0", "_blank");
  };

  return (
    <Corpo {...props}>
      <div name="tab-inicio" className="view-container tab-content">
        <div className="view-textos pane pane-game">
          <div
            className="content scroll-content ionic-scroll has-tabs-top"
            style={{ top: "56px" }}
          >
            <div
              className="scroll"
              style={{ transform: "translate3d(0px, 0px, 0px) scale(1)" }}
            >
              <div className="text-container">
                <h2>Perguntas Frequentes</h2>
                <br />
                <h3>1. Como instalo meu aplicativo?</h3>
                <p>
                  Você pode utilizar o conhecigame apenas acessando a url em seu navegador, seja pelo 
                  desktop ou celular. Caso queira manter um atalho para o jogo, basta seguir as 
                  instruções abaixo:
                </p>
                <div 
                  className="link-faq"
                  onClick={() => openLinkPwaAndroid()} >
                  Como usar Progressive Web Apps no <b>Android</b>
                </div>
                <div 
                  className="link-faq"
                  onClick={() => openLinkPwaComputador()} >
                  Como usar Progressive Web Apps no <b>Computador</b>
                </div>
                <h3>
                  2. Não consigo jogar porque recebo constantemente o aviso “Erro de conexão”. 
                  O que devo fazer?
                </h3>
                <p>
                  O aviso de “Erro de conexão. Tente novamente.” aponta que você está utilizando uma conexão 
                  instável com a internet. Você conseguirá jogar com uma conexão com a internet ruim, mas 
                  receberá os avisos de “Erro de conexão. Tente novamente.”. Para continuar o jogo, é necessário 
                  fechar o aviso clicando no “x” e selecionar novamente a reposta que já tinha escolhido (caso 
                  esteja na tela em que você deve responder uma pergunta).
                </p>
                <h3>
                  3. Como vejo qual é a versão que estou utilizando do ConheciGame?
                </h3>
                <p>
                  O número da versão do aplicativo está na aba “Sobre” (penúltima opção do menu lateral à direita).
                </p>
                <h3>
                  4. O aplicativo funciona em quais ambientes?
                </h3>
                <p>
                  A versão atual do aplicativo é compatível com os navegadores:
                </p>
                <ul className="lists-ul">
                  <li>
                    Chrome a partir da versão 40
                  </li>
                  <li>
                    Edge a partir da versão 79
                  </li>
                  <li>
                    Firefox a partir da versão 44
                  </li>
                  <li>
                    Chorme para Android a partir da versão 86
                  </li>
                  <li>
                    Android Browser a partir da versão 81
                  </li>
                  <li>
                    iOS Safari a partir da versão 14
                  </li>
                </ul>
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Corpo>
  );
}
